import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { deleteFeedbackType, feedbackTypeQueryKeys } from '../api/feedbackTypes.api';

export function useDeleteFeedbackType() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => deleteFeedbackType(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: feedbackTypeQueryKeys.all() });
      toast.success('Feedback type deleted successfully');
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to delete feedback type');
    },
  });
}
